import { Area, AreaChart, Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CHART_AXIS_TICK_FONT_SIZE_PX } from "../../config/appConstants";
import { formatUsd } from "../../config/trading";

const EARNINGS_CHART_HEIGHT_PX = 300;
const AXIS_TICK = { fill: "#888", fontSize: CHART_AXIS_TICK_FONT_SIZE_PX };
const TOOLTIP_STYLE = { background: "#050505", border: "1px solid #222", color: "#fff" };
const CHART_MARGIN = { left: 0, right: 8, top: 18, bottom: 0 };
const COMPARISON_BAR_COUNT = 8;

export function EarningsCharts({ series }) {
  return (
    <div className="earnings-chart-grid">
      <div data-testid="earnings-area-chart">
        <ResponsiveContainer width="100%" height={EARNINGS_CHART_HEIGHT_PX}>
          <AreaChart data={series} margin={CHART_MARGIN}>
            <defs><linearGradient id="earningsFill" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#00E676" stopOpacity={0.5} /><stop offset="95%" stopColor="#00E676" stopOpacity={0.02} /></linearGradient></defs>
            <CartesianGrid stroke="rgba(255,255,255,0.08)" vertical={false} />
            <XAxis dataKey="label" stroke="#666" tick={AXIS_TICK} />
            <YAxis stroke="#666" tick={AXIS_TICK} />
            <Tooltip contentStyle={TOOLTIP_STYLE} formatter={(value) => formatUsd(value)} />
            <Area type="monotone" dataKey="earnings" stroke="#00E676" fill="url(#earningsFill)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div data-testid="earnings-comparison-chart">
        <ResponsiveContainer width="100%" height={EARNINGS_CHART_HEIGHT_PX}>
          <BarChart data={series.slice(-COMPARISON_BAR_COUNT)} margin={CHART_MARGIN}>
            <CartesianGrid stroke="rgba(255,255,255,0.08)" vertical={false} />
            <XAxis dataKey="label" stroke="#666" tick={AXIS_TICK} />
            <YAxis stroke="#666" tick={AXIS_TICK} />
            <Tooltip contentStyle={TOOLTIP_STYLE} formatter={(value) => formatUsd(value)} />
            <Bar dataKey="comparison_earnings" fill="#333" name="Previous" />
            <Bar dataKey="earnings" fill="#00E676" name="Current" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}